<template>
    <tr class="table_head">

        <th>
            <TableHeadSortable
                :label="$t('modules.positions.index.positionsList.tableHeadName')"
                :isActive="sortName == 'name'"
                sortId="name"
                @sortChanged="handleSort"/>
        </th>

        <th><span >{{ $t('modules.positions.index.positionsList.tableHeadrefs') }}</span></th>

        <th>
            <!-- <span >{{ $t('modules.positions.index.positionsList.tableHeadevals') }}</span> -->
        </th>

        <th>
            <TableHeadSortable
                :label="$t('modules.positions.index.positionsList.tableHeaddate')"
                :isActive="sortName == 'created_at'"
                sortId="created_at"
                @sortChanged="handleSort"/>
        </th>

        <th class=""></th>


        <th class="icon_td"></th>
    </tr>
</template>

<script>
export default {
    name: 'TablePositionsHead',
    components: {
    },
    data(){
        return {
            sortName: null,
            sortType: "asc",
            inFavoriteSort: false
        }
    },
    computed: {
    },
    methods: {
        handleSort(sortType, sortId){
            this.sortType = sortType
            this.sortName = sortId
            this.$emit('onSort', this.sortName, this.sortType)
        }
    }
}
</script>
